import { AlertColor } from '@mui/material';

export type KeyedObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: string | number | KeyedObject | any;
};

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export interface AlertState {
  isOpen: boolean;
  severity: AlertColor;
  message?: React.ReactNode;
  autoHideDuration?: number;
}

export type TypeOverride<Type, Override> = Omit<Type, keyof Override> & Override;
